
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.58 15.845l1.734 1.733c.374-.225.821-.28 1.23-.158l3.452-3.454a3.564 3.564 0 010-3.884L5.545 6.631c-.41.118-.857.064-1.23-.16L2.58 8.206a.367.367 0 01-.52-.519l1.734-1.733A1.546 1.546 0 014.02 4.07a1.543 1.543 0 011.884-.226l1.731-1.736a.367.367 0 01.52.52L6.42 4.36c.224.374.28.821.16 1.23l3.453 3.454a3.564 3.564 0 013.884 0l3.451-3.454a1.555 1.555 0 01.16-1.23l-1.735-1.734a.367.367 0 01.52-.519l1.733 1.734a1.546 1.546 0 011.884.226c.508.508.584 1.293.226 1.884l1.736 1.733a.367.367 0 01-.52.52L19.64 6.47c-.374.225-.821.28-1.23.158l-3.452 3.454a3.559 3.559 0 010 3.886l3.452 3.45c.409-.12.856-.065 1.23.158l1.734-1.733a.367.367 0 01.519.519l-1.734 1.733c.356.59.282 1.374-.226 1.884a1.54 1.54 0 01-1.884.226l-1.733 1.734a.367.367 0 01-.52-.52l1.735-1.731a1.537 1.537 0 01-.16-1.23l-3.451-3.452a3.563 3.563 0 01-3.886 0l-3.451 3.452c.118.41.064.857-.16 1.23l1.734 1.734a.367.367 0 01-.519.519l-1.733-1.734a1.546 1.546 0 01-1.884-.226 1.543 1.543 0 01-.226-1.884l-1.733-1.733a.367.367 0 01.519-.52z"}})])
          )
        }
      }
    